import { render, staticRenderFns } from "./Seguranca.vue?vue&type=template&id=d41dc90e&"
import script from "./Seguranca.vue?vue&type=script&lang=js&"
export * from "./Seguranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports